/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/require-default-props */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import inRange from 'lodash/inRange';
import { Input, ErrorMessage } from '../InputRoomName/styles';

function InputStairs(props) {
  const {
    errorText,
    inputName,
    placeholder,
    showError,
    forwardedRef,
    onClick,
    id,
    value,
  } = props;

  const numbers = /[0-9]/;

  const isWholeNumber = (inputValue) => {
    const wholenumbers = /^\d+$/;

    return wholenumbers.test(inputValue);
  };
  const maxiChange = (newValue) => {
    const minimumValue = 0;
    const maximumValue = 1000;
    return inRange(newValue, minimumValue, maximumValue);
  };

  const handleInput = (e) => {
    const existingValue = e.target.value;
    const proposedInput = existingValue.concat(e.key);
    const isMax = maxiChange(proposedInput);
    if (!numbers.test(e.key) || !isMax) {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    const pastedText = e.clipboardData.getData('text');
    const existingValue = e.target.value;
    const proposedInput = existingValue.concat(pastedText);
    const isMaxPasted = maxiChange(proposedInput);
    if (!numbers.test(proposedInput) || !isMaxPasted || !isWholeNumber(proposedInput)) {
      e.preventDefault();
    }
  };

  const customRef = (el) => {
    if (forwardedRef?.current) {
      forwardedRef.current[inputName] = el;
    }
  };

  return (
    <>
      <Input
        id={id}
        ref={customRef}
        min="1"
        max="99"
        type="tel"
        name={inputName}
        placeholder={placeholder}
        defaultValue={value}
        onPaste={(e) => handlePaste(e)}
        onKeyPress={(e) => handleInput(e)}
        onClick={onClick}
        showError={showError}
      />
      <ErrorMessage showError={showError}>{errorText}</ErrorMessage>
    </>
  );
}

InputStairs.propTypes = {
  errorText: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  showError: PropTypes.bool.isRequired,
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.any })
  ]),
};

InputStairs.defaultProps = {
  id: 'id',
  value: undefined,
  forwardedRef: {},
};

export default InputStairs;
